// extracted by mini-css-extract-plugin
export var numpadContainer = "_ot-1";
export var phoneButton = "_ot-0";